import React from 'react';
import {ButtonBase} from '@material-ui/core';
import QCTooltip from '@pluto/qc-tooltip';
import {
    SetInpointIcon,
    SetOutpointIcon,
    GoToInIcon,
    GoToOutIcon,
    ClearPointsIcon,
} from '../../icons';

import './PointControls.scss';

interface PointControlsProps {
    onSetIn: () => void;
    onSetOut: () => void;
    onGoToIn: () => void;
    onGoToOut: () => void;
    onClearPoints: () => void;
}

export default function PointControls(props: PointControlsProps) {
    const {onSetIn, onSetOut, onClearPoints, onGoToIn, onGoToOut} = props;

    return (
        <div className="flex-container center-container">
            <QCTooltip title="Set Selection In (I)" arrow>
                <ButtonBase
                    onClick={onSetIn}
                    aria-label="Set Selection In"
                    aria-keyshortcuts="I"
                >
                    <SetInpointIcon />
                </ButtonBase>
            </QCTooltip>
            <QCTooltip title="Set Selection Out (O)" arrow>
                <ButtonBase
                    onClick={onSetOut}
                    aria-label="Set Selection Out"
                    aria-keyshortcuts="O"
                >
                    <SetOutpointIcon />
                </ButtonBase>
            </QCTooltip>
            <QCTooltip title="Clear Selection (Ctrl + Shift + X)" arrow>
                <ButtonBase
                    onClick={onClearPoints}
                    aria-label="Clear Selection"
                    aria-keyshortcuts="Ctrl+Shift+X"
                >
                    <ClearPointsIcon />
                </ButtonBase>
            </QCTooltip>
            <QCTooltip title="Go To Selection In (Shift + I)" arrow>
                <div>
                    <ButtonBase
                        onClick={onGoToIn}
                        aria-label="Go To Selection In"
                        aria-keyshortcuts="Shift+I"
                    >
                        <GoToInIcon />
                    </ButtonBase>
                </div>
            </QCTooltip>
            <QCTooltip title="Go to Selection Out (Shift + O)" arrow>
                <div>
                    <ButtonBase
                        onClick={onGoToOut}
                        aria-label="Go To Selection Out"
                        aria-keyshortcuts="Shift+O"
                    >
                        <GoToOutIcon />
                    </ButtonBase>
                </div>
            </QCTooltip>
        </div>
    );
}
